import { useFormContext, type FieldValues } from 'react-hook-form'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import { Input } from '../ui/input'

export interface NumberInputProps {
	name:         string
	label?:       string
	placeholder?: string
	disabled?:    boolean
	prefix?:      React.ReactNode
	suffix?:      React.ReactNode
	min?:         number
	max?:         number
	step?:        number | 'any'
	className?:   string
}

export function NumberInput({ name, label, placeholder, disabled, prefix, suffix, min, max, step, className }: NumberInputProps) {
	const form = useFormContext<FieldValues>()
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem className={className}>
					{label && <FormLabel>{label}</FormLabel>}
					<FormControl>
						<Input
							{...field}
							type="number"
							value={(field.value as number | string | undefined) ?? ''}
							placeholder={placeholder}
							disabled={disabled}
							prefix={prefix}
							suffix={suffix}
							min={min}
							max={max}
							step={step}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
